<template>
  <MarketWrapper
    :initial-fields="initialFields"
    title-hero="Sustainability"
    :image-hero="heroImage"
    :brochure-file-info="brochureFileInfo"
    :title-page="titlePage"
    :icon="icon"
    :tabs="tabs"
    has-bookable-demo
    @active-tab-changed="changeActiveTab"
  >
    <div class="relative pt-6">
      <slot />
    </div>
  </MarketWrapper>
</template>

<script setup lang="ts">
import MarketWrapper from '~/components/shared/services/MarketWrapper.vue'

import type { TMarketServiceConfig } from '~/src/types/markets'
import type { TFileDownloadInfo } from '~/src/types/download'
import { ESG } from '~/constants/services/constants'
import { getSustainabilityTabs } from '~/src/utils/tabs'
import type { TTab } from '~/src/types/ui'

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  market: TMarketServiceConfig
  hideBatteryEmissionsTab?: boolean
  initialFields: string[]
  heroImage: string
  brochureFileInfo: TFileDownloadInfo
  hasBookableDemo?: boolean
}>()

const router = useRouter()

const titlePage = ref(`${props.market.name} ${ESG.name}`)
const icon = ref(props.market.iconColor)

const { isAuthenticated } = useAuthentication()

const tabs = computed<TTab[]>(() => {
  return getSustainabilityTabs({
    market: props.market.slug,
    hideOverview: isAuthenticated(),
    hideBatteryEmissions: props.hideBatteryEmissionsTab,
  })
})

const changeActiveTab = (tab: string) => {
  router.push(tab)
}
</script>
